import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UsersAdminService } from '../services/users-admin.service';
import { LaunchpadUser } from '../models/launchpad-user';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-activate-user-modal',
    templateUrl: './activate-user-modal.component.html',
    styleUrls: ['./activate-user-modal.component.sass'],
    standalone: false
})
export class ActivateUserModalComponent {

  @Input({ required: true }) user!: LaunchpadUser;

  submitting: boolean = false;
  error: boolean = false;

  get reactivateMode(): boolean {
    return !this.user.isActive;
  }

  constructor(protected activeModal: NgbActiveModal,
              private userAdminService: UsersAdminService) {
  }

  confirmActivation(): void {
    console.log(`Confirmed ${this.reactivateMode ? 'activation' : 'deactivation'}`);
    this.submitting = true;
    this.error = false;
    this.getActivationRequest().subscribe(
      updatedUser => {
        this.submitting = false;
        this.activeModal.close(updatedUser);
      },
      () => {
        this.submitting = false;
        this.error = true;
      });
  }

  private getActivationRequest(): Observable<LaunchpadUser | undefined> {
    return this.reactivateMode
      ? this.userAdminService.activateUser(this.user.emailAddress)
      : this.userAdminService.deactivateUser(this.user.emailAddress);
  }

}
